<template>
  <div id="edit-modal-company" class="modal modal-fixed-footer" ref="editModal">
    <div class="modal-content">
      <div class="processing-overlay" v-if="isProcessing">
        <!-- isProcessing -->
        <div class="preloader-wrapper small active">
          <div class="spinner-layer spinner-blue-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
      </div>

      <input
        type="file"
        @change="$_addImage"
        ref="file"
        style="display: none"
        accept="image/jpeg"
        multiple
      />

      <div class="row flex-row" style="margin-bottom: 0px !important;">
        <div class="col s12" v-if="!hasImagesX">
          <div class="valign-wrapper">
            <div class="no-image">
              <i class="material-icons grey-text text-darken-2">image</i>
            </div>
          </div>
        </div>
        <div
          class="col s6 m4 preview-image"
          v-for="(image, index) in images"
          :key="index"
        >
          <button
            class="btn-floating btn-small white waves-effect"
            @click="$_deleteImage(index)"
          >
            <i class="material-icons-outlined grey-text text-darken-3">
              delete
            </i>
          </button>
          <div class="image">
            <img :src="image.previewImage" alt="" v-if="image.isNew" />
            <img :src="image.link" alt="" v-else />
          </div>
          <!-- <div class="col s12">
            <button
              v-if="dataImage.link"
              class="btn grey lighten-4 waves-effect btn-rounded z-depth-0 grey-text text-darken-3 icon-right"
              @click="$_deleteImage()"
            >
              <i class="material-icons-outlined right grey-text text-darken-3"
                >remove</i
              >
              REMOVE
            </button>
          </div> -->
        </div>
        <div class="col s12 center-align">
          <button
            class="btn grey lighten-4 waves-effect btn-rounded z-depth-0 grey-text text-darken-3 icon-right"
            @click="$_openFile()"
            v-if="!hasImagesX"
          >
            <i class="material-icons-outlined right grey-text text-darken-3"
              >add</i
            >
            Click to upload image
          </button>

          <button
            v-else
            class="btn grey lighten-4 waves-effect btn-rounded z-depth-0 grey-text text-darken-3 icon-right"
            @click="$_openFile('add_more')"
          >
            <i class="material-icons-outlined right grey-text text-darken-3"
              >add</i
            >
            Add More Images
          </button>
        </div>
        <div class="clear"></div>
        <div class="special-guidelines">
          <div class="card z-depth-0 grey lighten-4">
            <div class="card-content">
              <b>Note</b>: The maximum file size for each image uploaded is 5MB
              (megabytes). If you need assistance with reducing the file size of
              your images, please click
              <a href="https://www.reduceimages.com/" target="_blank">here</a>
              for assistance. You cannot upload more than 10 images per
              category.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        @click="$_close()"
        class="btn-flat red-text text-darken-4 waves-effect"
      >
        Close
      </button>
      <button
        @click="$_saveImage()"
        :disabled="!canSaveX"
        class="btn-flat green-text waves-effect"
      >
        Save
      </button>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import M from "materialize-css";

import axios from "axios";
import { getCookie } from "@/common/util";
import { deleteMediaFile, updateUserProfile } from "@/api/user.api";
import { mapActions } from "vuex";
import { payload } from "../../schemas/welcome";
import { toastMessage } from "../../common/util";
export default {
  name: "supportImagesModal",
  props: {
    dataAction: {
      type: String,
      default: "",
    },
    dataImage: {
      type: Object,
      default: () => false,
    },
    dataHomeProfileImages: {
      type: Object,
      default: () => false,
    },
    dataKey: String,
  },
  data() {
    return {
      addingMore: false,
      modal: {
        instance: null,
        options: {
          dismissible: false,
        },
      },

      editData: {},
      editAcfData: {},
      isProcessing: false,
      image: null,
      previewImage: null,
      name: "",
      address: "",

      images: [],
    };
  },
  beforeDestroy() {
    if (this.modal.instance !== null) {
      this.modal.instance.close();
      setTimeout(() => {
        this.modal.instance.destroy();
      }, 90);
    }
  },
  computed: {
    canSaveX() {
      const val = this.images.filter(({ isNew, shouldDel }) => isNew);
      return val.length > 0;
    },
    hasImagesX() {
      return this.images.length > 0;
    },
    // imagesX() {
    //   return this.images.filter(({ shouldDel }) => !shouldDel);
    // },
  },
  mounted() {
    this.$_initModal();
    this.$_setImages();
  },
  methods: {
    ...mapActions("User", ["updateUser"]),
    $_initModal() {
      this.modal.instance = M.Modal.init(
        this.$refs.editModal,
        this.modal.options
      );
      setTimeout(() => {
        this.modal.instance.open();
      });
    },
    $_setImages() {
      if (this.dataHomeProfileImages[this.dataKey]) {
        this.images = this.dataHomeProfileImages[this.dataKey].images.map(
          (item) => {
            return {
              isNew: false,
              ...item,
            };
          }
        );
      }
    },
    $_openFile() {
      this.$refs.file.click();
      this.addingMore = true;
    },
    $_addImage($event) {
      const files = $event.target.files;

      Object.keys(files).some((key) => {
        if (files[key].size > 2 * 1024 * 1024) {
          toastMessage("Maximum file size is 2MB.");
          return true;
        }

        if (files[key].type !== "image/jpeg") {
          toastMessage("JPEG image only.");
          return true;
        }
        const imageObj = {
          isNew: true,
          previewImage: URL.createObjectURL(files[key]),
          image: files[key],
          shouldDel: false,
        };

        this.images.push(imageObj);
      });
    },
    $_setImage($event) {
      const file = $event.target.files[0];
      this.previewImage = URL.createObjectURL(file);
      this.image = file;
    },
    async $_deleteImage(index) {
      if (this.isProcessing) return;
      this.isProcessing = true;

      if (this.images[index].isNew) {
        this.images = this.images.filter((_, i) => i !== index);
        this.isProcessing = false;
        return;
      }

      try {
        const idx = this.images[index].id;
        await deleteMediaFile(idx);
        this.images = this.images.filter((_, i) => i !== index);
        let dataObj = { ...this.dataHomeProfileImages };

        dataObj[this.dataKey].images = dataObj[this.dataKey].images.filter(
          ({ id }) => id !== idx
        );

        let payload = {
          fields: {
            home_profile_images: JSON.stringify(dataObj),
          },
        };

        await this.$_updateUserProfile(
          this.$store.state.User.user.profile,
          payload
        );
        this.isProcessing = false;
      } catch (error) {
        this.isProcessing = false;
      }
    },
    async $_updateUserProfile(profile, payload) {
      await updateUserProfile(profile, payload)
        .then((res) => {
          this.updateUser({ ...payload.fields });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async $_saveImage() {
      if (this.isProcessing) return;
      this.isProcessing = true;
      const token = getCookie("token");
      const createImage = async (formData) => {
        const { data } = await axios.post(
          "https://api.sldb.lc/wp-json/wp/v2/media",
          formData,
          {
            headers: {
              Authorization: "Bearer" + token,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (data) {
          return { id: data.id, link: data.source_url };
        }
      };

      let promisesArr = [];
      this.images.map((item) => {
        if (item.isNew) {
          let formData = new FormData();
          const newName = new Date().getTime() + item.image.name;
          formData.append("file", item.image, newName);

          promisesArr.push(createImage(formData));
        } else if (item.shouldDel) {
          promisesArr.push(deleteImage(item));
        }
      });

      Promise.allSettled(promisesArr).then(async (results) => {
        let dataObj = { ...this.dataHomeProfileImages };

        results.map(({ value }) => {
          if (value) {
            const { added, ...results } = value;
            dataObj[this.dataKey].images.push({ ...results });
          }
        });

        let payload = {
          fields: {
            home_profile_images: JSON.stringify(dataObj),
          },
        };
        await this.$_updateUserProfile(
          this.$store.state.User.user.profile,
          payload
        );
        this.isProcessing = false;

        this.$_setImages();
      });

      // if (this.dataAction === "add") {
      //   createImage();
      // } else {
      //   this.$_deleteImage(createImage);
      // }
    },
    $_close() {
      this.modal.instance.close();
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
#edit-modal-company {
  border-radius: 10px;

  .no-image {
    width: 96px;
    height: 96px;
    text-align: center;
    line-height: 96px;
    margin: auto;
    background: #f6f6f6;
    border-radius: 50%;
    margin-bottom: 16px;
    i {
      font-size: 48px;
      line-height: 96px;
    }
  }
}
.flex-row {
  display: inline-flex;
  flex-wrap: wrap;
  .col {
    &.preview-image {
      margin-left: 0px;
      position: relative;
      margin-right: 0px;
      button {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 24px;
      }
    }
    .image {
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #e9e9e9;
      img {
        width: 100%;
      }
    }
  }
}
.processing-overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
  .preloader-wrapper {
    left: 50%;
    top: 50%;
    z-index: 9;
    margin-left: -18px;
    margin-top: -18px;
  }
}

.preview-image {
  position: relative;
  margin-bottom: 1rem;
}
</style>
